export default __webpack_public_path__ + "static/media/Role_R.695a7c36.svg";